import React from "react";
import Link from "src/components/common/Links/Link";
import { Box, Chip } from "@mui/material";
import { CategoryExtraLinksItemsSchema } from "src/models/categoryBrand/types";
import { SubcategoriesSchema } from "src/models/category/getSubcategories";
import { createUrl } from "src/utils/helpers/url/createUrl";
import { DEFAULT_CITY } from "src/utils/constant/constant";
import paths from "src/router/paths";

interface CategoryBottomLinkSectionProps {
  data: CategoryExtraLinksItemsSchema[] | SubcategoriesSchema[];
  city?: string;
}

const CustomChipList: React.FC<CategoryBottomLinkSectionProps> = ({
  data,
  city,
}) => {
  return (
    <Box flexWrap="wrap" flexDirection="row" display="flex">
      {data &&
        data.map((value, index) => (
          <Link
            sx={{ textDecoration: "none", cursor: "auto" }}
            key={value.id}
            href={
              city
                ? createUrl([city || DEFAULT_CITY, paths.CATALOG, value.slug])
                : value.slug
            }
          >
            <Chip
              sx={{
                marginBottom: 1.5,
                marginRight: 1,
                flexWrap: "wrap",
                height: "auto",
                minHeight: "32px",
                cursor: "pointer",
                ":hover": {
                  backgroundColor: "#ccc",
                },
                ".css-6od3lo-MuiChip-label": {
                  whiteSpace: "normal",
                },
              }}
              key={index}
              label={value.name}
            />
          </Link>
        ))}
    </Box>
  );
};

export default CustomChipList;
